<template>
  <div>
    <el-checkbox
      style="margin-bottom: 16px"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      :disabled="isdisabled"
      @change="handleCheckAllChange"
      >全选</el-checkbox
    >
    <el-checkbox-group
      style="margin-bottom: 10px"
      v-model="checkItem"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        style="margin-bottom: 16px"
        v-for="warningItem in pushData"
        :label="warningItem.id"
        :key="warningItem.id"
        :disabled="isdisabled"
        >{{ warningItem.name }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "WarningCheck",
  props: {
    pushData: {
      type: Array,
      default: () => [],
    },
    warningType: {
      type: String,
      default: "",
    },
    noChangeId: {
      type: Boolean,
      default: '',
    },
  },
  watch: {
    checkItem: {
      handler(nval, oval) {
        this.$emit("changeIds", { type: this.warningType, data: nval });
      },
      immediate: true,
    },
    noChangeId: {
      handler(nval, oval) {
        if(this.warningType === 'pushChannelTypeVOs'&& nval){
          this.checkItem = []
          this.isdisabled = true
        } else if (this.warningType === 'pushChannelTypeVOs'&& !nval){
          this.isdisabled = false
        }
       
      },
    },
    pushData: {
      handler(nval, oval) {
        this.getIsHaving();
      },
    },
  },
  data() {
    return {
      isIndeterminate: true,
      checkItem: [],
      checkAll: false,
      isdisabled:false,
    };
  },
  mounted() {
    this.getIsHaving();
  },
  methods: {
    getIsHaving() {
      debugger
      this.pushData.map(item => {
        if (item.value) {
          this.checkItem.push(item.id)
        }
      })
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkItem = this.pushData.map((item) => {
          return item.id;
        });
      } else {
        this.checkItem = [];
      }
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.pushData.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.pushData.length;
    },
  },
};
</script>
